export { default } from './ModulAvis';
